<template>
    <section class="tool-holder">
        <div class="tool-container">
            <div class="tool__question-holder">
                <h3 class="tool__subtitle">{{ question.number }}</h3>
                <h2 class="tool__title">{{ question.title }}</h2>
                <div class="tool__text-holder" v-if="question.text">
                    <p class="tool__text">{{ question.text }}</p>
                </div>
            </div>
            <div class="tool__answer-holder tool__answer-holder--center radio-button-container">
                <div v-for="(answer, index) in question.answers" :key="question.slug + index" class="checkbox-holder checkbox-holder--boxed checkbox-holder--double" :class="{ 'checkbox-holder--disabled' : isInputDisabled && answer.text !== 'Geen van alle' }" @click.prevent="addToStore(question.slug, answer.text, index)">
                    <input
                        type="checkbox"
                        :id="answer.text"
                        :ref="question.slug + index"
                        :disabled="isInputDisabled && answer.text !== 'Geen van alle'"
                        :checked="answers[index] && answers[index].length && answer.text !== 'Geen van alle'"
                    />
                    <label :for="answer.text">{{ answer.text }}</label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import store from '../../store/store';

export default {
    props: {
        question: {
            type: Object
        }
    },

    data() {
        return {
            store,
            answers: [],
            isInputDisabled: false,
        }
    },

    created() {
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    },

    mounted() {
        // Set empty arrays for available answers in this question.
        for (let i = 0; i < this.question.answers.length; i++) {
            this.answers[i] = this.store.questionAnswers[this.store.currentQuestionIndex].answers[i] !== undefined ? this.store.questionAnswers[this.store.currentQuestionIndex].answers[i] : [];
        }

        this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
    },

    methods: {
        addToStore(slug, value, index) {
            const checkbox = this.$refs[slug + index][0];
            const isChecked = !checkbox.checked;
            this.$refs[slug + index][0].checked = isChecked;

            // Clear the array and don't add anything if 'Geen van alle' is checked.
            if (value === 'Geen van alle') {

                // Disable input and clear answers array.
                this.isInputDisabled = isChecked;
                for (let i = 0; i < this.question.answers.length; i++) {
                    this.answers[i] = [];
                }

                // Emit last-question-change event to update next / result button caption.
                EventBus.$emit('last-question-change', isChecked);

                // Set checkbox again to work around a strange bug where the 'Geen van alle' checkbox won't update the first time you click it.
                setTimeout(() => {
                    this.$refs[slug + index][0].checked = isChecked;
                }, 100);

                return;
            }

            // Check if the question is a side question
            if (this.question.isSideQuestion) {
                this.addSideQuestionToStore(isChecked, value, index);
                return;
            }

            // When the checkbox is not checked, it needs to be removed form the array
            if (!isChecked) {
                // set value corresponding to that question index to null
                this.answers[index] = [];
                if (value == 'Zolder') {
                    this.answers[index +1] = [];
                }
                this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
                return;
            }

            // Add answers to the array
            this.answers[index] = value;
            if (value == 'Zolder') {
                this.answers[index +1] = value;
            }
            this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
        },

        addSideQuestionToStore(isChecked, value, index) {
            // When the checkbox is not checked, it needs to be removed form the array
            if (!isChecked) {
                // set value corresponding to that question index to null
                this.answers[index] = [];
                this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] = this.answers;
                return;
            }

            // Add answers to the array
            this.answers[index] = value;
            this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] = this.answers;
        },
    },

    updated() {
        // Reset answers for when there are multiple radio questions after each other. This will prevent the template to have a success class on the fields when the user hasn't selected anything
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    }
}
</script>
